import { render, staticRenderFns } from "./downloadFile_nfc.vue?vue&type=template&id=1fe66444&scoped=true"
import script from "./downloadFile_nfc.vue?vue&type=script&lang=js"
export * from "./downloadFile_nfc.vue?vue&type=script&lang=js"
import style0 from "./downloadFile_nfc.vue?vue&type=style&index=0&id=1fe66444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe66444",
  null
  
)

export default component.exports